import { memo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';

// project imports
import menuItem from 'layout/MainLayout/menu-items';
import { menuItemsOnlyReadUser } from 'layout/MainLayout/menu-items';
import NavGroup from './NavGroup';
import { NavItemType } from 'types';
import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';
import useConfig from 'hooks/useConfig';
import keycloak from '../../../Keycloak';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    const { layout } = useConfig();

    // TODO - Apaño para mostrar un menú solo con el historial de operaciones
    const allowedMenuItems = !keycloak.realmAccess?.roles.includes('readonly') ? menuItem : menuItemsOnlyReadUser;

    // last menu-item to show in horizontal menu bar
    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    let lastItemIndex = allowedMenuItems.items.length - 1;
    let remItems: NavItemType[] = [];
    let lastItemId: string;

    if (lastItem && lastItem < allowedMenuItems.items.length) {
        lastItemId = allowedMenuItems.items[lastItem - 1].id!;
        lastItemIndex = lastItem - 1;
        remItems = allowedMenuItems.items.slice(lastItem - 1, allowedMenuItems.items.length).map((item) => ({
            title: item.title,
            elements: item.children
        }));
    }

    const navItems = allowedMenuItems.items.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} lastItem={lastItem!} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
